package org.multiplatform.kotfolio.pages.kids

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.WebImage
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import org.multiplatform.kotfolio.util.Resources

@Page("weather")
@Composable
fun KidsWeatherPage() {
    BlogLayout(
        PageProperties(
            "Weather",
            "Weather changes from time to time. When one type of weather continues for many days it is called a season."),
        BlogProperties("Kids", "Weather")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            WebImage(
                src = Resources.Images.WEATHER,
                modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                contentDescription = "Weather"
            )

            SpanText(
                text = "Weather",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Weather is the day-to-day condition over a particular place. A person who studies the weather is called meteorologist. Weather predictions are made by forecasters who you often see on television.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Weather is how air, wind, rain and heat feel in any place on any day. (The weather of a place can change in a few hours or even in a few minutes. Weather changes from time to time.)",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Sometimes the weather is cloudy, while at other times it is sunny. At times it rains, while at other times it is dry and windy.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The weather controls where we live, what we wear, what we eat and what we do.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Sunny Days",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "If the Sun shines brightly, we say it is sunny. On sunny days the weather is warm. We feel very hot. We sweat (પરસેવો), and feel sticky and uncomfortable.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "On sunny days we use fans, air conditioners and air coolers to cool ourselves. We like to eat ice-cream, watermelon and cold drinks.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We wear cotton clothes because they keep us cool. We like to drink cold fruit juices, lassi, and eat ice creams.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Rain Days",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "On rainy days the sky is covered with grey clouds that bring rain. Thunder and lightning can be seen in the sky. We sometimes see a rainbow in the sky.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When we go out in the rain, we use umbrellas, raincoats and gumboots. We love to jump in the puddles (ખાબોચિયાં), splash water on each other and make paper boats.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Cold days",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "On cold days, a cold wind blows and the air is chilly (ઠંડી).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When it is cold, we wear woollen clothes, such as coats, mufflers and caps to keep ourselves warm. People also make a bonfire with wooden sticks to stay warm. We prefer to eat hot foods and drink soups when it is cold.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Windy day",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "If a strong wind is blowing, we say it is a windy day. We see the trees and branches swaying and feel the wind on our face. Things that are light such as hats, papers and even clothes may fly away on windy days.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Cloudy days",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "On a cloudy day, clouds block the Sun. There is little or no sunshine. The day looks dull, but feels cool. We can go for a picnic on a cloudy day because the weather is pleasant (cool and comfortable - સુખદ).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Season - Stays for long period.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When one type of weather continues for many days it is called a season. Most countries around the world have four seasons in a year. They are summer, autumn, winter and spring. In India, we have a monsoon season as well.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Summer - April to June",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It is the hottest season of the year. In India, the summer season is from April to June.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Autumn (પાનખર)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The weather is neither hot nor cold. Trees shed their leaves during autumn. (In autumn leaves fall off the trees.) This is the season when summer changes to winter. In India, the autumn seasons is from September to November.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Monsoon - Starts after summer and lasts from July till September",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "India also has a monsoon season. It is the rainy season that starts after summer and lasts from July till September.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Winter",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It is the coldest season of the year. We wear woolen (ઊની), clothes during winter. In India, the winter season is from December to January.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Spring - February to March",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In spring season flowers start to grow and bloom.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Rainbow",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Some time, after heavy rains, we see a rainbow in the sky. the rainbow has seven colours.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Violet, indigo, blue, green, yellow, orange and red.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When the sun shines through the rain, an arch (કમાન) of colours is formed (રચાય) in the sky.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Smog",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When a cloud of pollution hangs over a city.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Sleet",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When snow or hail is mixed with rain.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Typhoon",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When a spiral arrangement of thunderstorms produces winds and heavy rains.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Hailstone",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When small hard balls of ice fall from the sky.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Water cycle (hydrologic cycle)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                SpanText(
                    text = "Evaporation",
                    modifier = Modifier
                        .fontSize(FontSize.Medium)
                        .fontWeight(FontWeight.Bold)
                )

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Energy from the sun heats up the surface of the Earth, causing the temperature of the water in our rivers, lakes and oceans to rise. When this happens, some of the water “evaporates” into the air, turning into a gas called “vapour“.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Plants and trees also lose water to the atmosphere through their leaves. This process is known as “transpiration“.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }

                SpanText(
                    text = "Condensation",
                    modifier = Modifier
                        .fontSize(FontSize.Medium)
                        .fontWeight(FontWeight.Bold)
                )

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "As water vapour rises up high into the sky, it cools and turns back into a liquid, forming clouds. This process is called “condensation“. Currents high up in the air move these clouds around the globe.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }

                SpanText(
                    text = "Precipitation",
                    modifier = Modifier
                        .fontSize(FontSize.Medium)
                        .fontWeight(FontWeight.Bold)
                )

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "When too much water has condensed, the water droplets in the clouds become too big and heavy for the air to hold them. And so they fall back down to Earth as rain, snow, hail or sleet, a process known as “precipitation“.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }

                SpanText(
                    text = "Collection",
                    modifier = Modifier
                        .fontSize(FontSize.Medium)
                        .fontWeight(FontWeight.Bold)
                )

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "The fallen precipitation is then “collected” in bodies of water – such as rivers, lakes and oceans – from where it will eventually evaporate back into the air, beginning the cycle all over again.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }

                Ol {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Which Shakespearean play was the basis of Habib Tanvir's 'Kamdev ka Apna Basant Ritu ka Sapna'? A Midsummer Night's Dream",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Which of the following words is used to describe a drizzle or a light rain? Rimjhim, Taabadtod, Chhama chham, Moosaladhaar",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "In India, which season is chiefly associated with the month of December? Winter",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Layers of the Earth's atmosphere",
                modifier = Modifier
                    .fontSize(FontSize.Medium)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Troposphere ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "This is the lowest layer, where we live and breathe. It's where almost all the weather you experience happens, from rain and wind to sunshine and snow",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Stratosphere ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "This layer is above the troposphere. It contains the ozone layer, El which protects us from the Sun's harmful ultraviolet (UV) rays",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Mesosphere ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "Above the stratosphere, this is the coldest layer of the atmosphere. When meteors enter our atmosphere, they usually burn up in the mesosphere, creating shooting stars.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Thermosphere ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "This layer is above the mesosphere and is very hot. Satellites and the International Space Station orbit within this layer It also contains the ionosphere, which helps with radio communication",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Exosphere ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "This is the outermost layer of the atmosphere, where it slowly fades into outer space. The air here is extremely thin",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Discuss the different scientific tools used by meteorologists to measure weather. Explain what each tool measures and how it works.",
                modifier = Modifier
                    .fontSize(FontSize.Medium)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Thermometer ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "Measures air temperature using mercury, alcohol, or digital sensors.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Rain Gauge ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "Collects and measures the amount of rainfall in millimetres.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Barometer ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "Measures atmospheric pressure. A fall in pressure usually indicates bad weather.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Wind Vane ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "Shows the direction from which the wind is blowing.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Anemometer ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "Measures wind speed using rotating cups.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Hygrometer ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "Measures humidity (moisture in the air).",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Logical Order",
                modifier = Modifier
                    .fontSize(FontSize.Medium)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "(A) - Rain, (B) - Cooling, (C) - Condensation, (D) - Heating, (E) - Evaporation: (D), (E), (B), (C), (A)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Fill in the blanks.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Any kind of water that falls from the atmosphere to the Earth is called ________________. precipitation",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A low-pressure system can be called a ________________ or cyclone. depression",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The amount of water vapour in the air is called ________________. humidity",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The unit for measuring air pressure is the ________________. millibar (mb)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The India Meteorological Department (IMD) is our main agency for ________________ forecasting. weather",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The instrument used to measure humidity is called ________________. hygrometer",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The lowest layer of the Earth's atmosphere is the ________________. troposphere",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Questions",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "During the water cycle, what is the process called when the sun heats up water in rivers and oceans, turning it into water vapor?",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Evaporation",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Describe the various types of precipitation. How does precipitation happen?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Precipitation is any kind of water that falls from the atmosphere to the Earth. It happens when water vapour in the air cools down and change back into a liquid or a solid.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )

                        SpanText(
                            text = "There are several different forms precipitation:",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )

                        Ol {
                            SpanText(
                                text = "Rain is liquid water that falls from the clouds.",
                                modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                            )

                            SpanText(
                                text = "Snow is frozen water that falls as soft white flakes.",
                                modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                            )

                            SpanText(
                                text = "Sleet is a mix of frozen and partly frozen rain.",
                                modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                            )

                            SpanText(
                                text = "Hail is precipitation in the form of small hard balls of ice.",
                                modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                            )
                        }
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is weather, and what are its main components?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Weather is what the air around Earth is like at a certain time and place. It includes temperature, precipitation, atmospheric pressure, wind and humidity.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Describe the troposphere and its importance.",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The troposphere is the lowest layer of the atmosphere where almost all weather occurs it is thicker at the equator and thinner at the poles.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is precipitation? Name two different forms of it.",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Precipitation is any kind of water that falls from the atmosphere to the earth it happens when water vapour in the air cools down and changes back into a liquid or solid. The different forms of precipitation are rain and snow.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why is it important to measure weather elements using common standards?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "We need to measure whether elements precisely using common standard. Knowing the exact temperature and how much rain well helps everyone understand and compare whether conditions accurately.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is an Automated Weather Station (AWS), and what is its main advantage?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Automated weather station collect information on temperature humidity wind speed and direction rain and air pressure. A w s provide quick and exact weather information which is useful for feel like farming and watching our environment. ",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why do people feel dizzy or tired when they climb very high mountains?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Air pressure is usually higher near the sea coast and lower as we go higher up in the mountains full stop this is why we might feel breathless disease or tired if we climb very high there is less air pressure and so less oxygen.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the difference between sleet and hail?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Sleet is a mix of frozen and partly frozen rain.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )

                        SpanText(
                            text = "Hail is precipitation in the form of small, hard balls of ice.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Explain the concept of humidity and how it is measured. Provide real-life examples of how humidity affects our daily lives.",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Humidity is the amount of water vapour in the air. On a humid day, the air feels sticky because there's a lot of water vapour in it.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )

                        SpanText(
                            text = "To measure humidity, the amount of water vapour in the air, we use hygrometer. We might notice wet clothes dry faster on a less humid day. Also, we sweat more on humid days because our sweat can't evaporate easily into the already watery air.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why is atmospheric pressure so important for understanding weather? Explain how it can affect human beings and weather patterns.",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Atmospheric Pressure (Air Pressure) is the weight of the air pressing down on Earth's surface. When the air feels 'heavy' before a storm, that's often due to changes in air pressure. Air pressure is usually higher near the sea coast and lower as we go higher up into the mountains. This is why you might feel breathless, dizzy, or tired if you climb very high, there's less air pressure and so less oxygen. Sometimes, air pressure drops a lot, creating a 'depression' or 'low-pressure system', which can even become a storm or cyclone.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the name of the scientist who studies weather?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Meteorologist",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Which weather element is the weight of the air pressing down on Earth's surface?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Atmospheric Pressure",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Which of the following is not a form of precipitation?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Dew",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }
            }

            //Separation of Insoluble Solid from Liquid
            //The process of separating solid particles from a liquid using a filter is called:  Evaporation, Distillation, Filtration, Sedimentation
            //In the Hindu calendar, which rainy month comes after Chaitra, Vaisakh, Jyeshta, and Ashadh? Shraavan, Bhadrapad, Margashirsh, Magha
            //bonfire - A large fire that you build with wooden sticks, fire and stones (લાકડાના લાકડીઓ, અગ્નિ અને પથ્થરોથી બનાવેલી મોટી આગ)
            //pleasant - cool and comfortable
            //Snow - The winter sport of skiing takes place on which surface?
            //Tenzing Norgay - After whom is India's National Adventure Award, given to honour adventure on sea, air, and land, named?
        }
    }
}

